import { render, staticRenderFns } from "./SubscriptionMenu.vue?vue&type=template&id=5fe60064&"
import script from "./SubscriptionMenu.vue?vue&type=script&lang=js&"
export * from "./SubscriptionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports